import { Outlet } from "react-router-dom";
import "../css/center.scss";
export const Center = () => {
  return (
    <div className="center">
      <Outlet />
    </div>
  );
};
